<div class="dropdown">
    <div class="input">
        <input
            #input
            [placeholder]="placeholder"
            [disabled]="disabled"
            class="text-input text-search"
            type="text"
            [attr.data-e2e-hook]="e2eHook"
        />
        <span class="magnifier-icon-container">
            <span class="magnifier-icon"></span>
        </span>
    </div>
    <div class="items" [hidden]="!displayItems">
        <ul class="items-list">
            <li
                *ngFor="let item of itemsToDisplay | async; let i = index"
                class="item"
                (click)="selectItem(item)"
                [ngClass]="{
                    'item-text-selected': isSelected(item),
                    'item-unavailable': item.unavailable
                }"
                [attr.data-e2e-hook]="e2eHook + '-item-' + i"
            >
                <div *ngFor="let textRow of item.textRows" class="item-row">
                    {{ textRow }}
                </div>
            </li>
            <li class="not-found-item" *ngIf="(itemsToDisplay | async)?.length === 0">
                <div class="item-row">{{ notFoundText }}</div>
            </li>
        </ul>
    </div>
</div>
